export const defaultInlineDocument = {
  rootNodeId: 'lkmVag',
  nodes: {
    lkmVag: {
      type: 'Document',
      css: {
        display: 'flex',
        alignItems: 'stretch',
        paddingTop: 16,
        paddingLeft: 16,
        paddingRight: 16,
        flexDirection: 'column',
        paddingBottom: 16,
        justifyContent: 'flex-start',
      },
    },
  },
};
